export default __webpack_public_path__ + "static/media/coti.c04b0011.svg";